<template>
  <div class="home">
    <header class="py-8 md:py-24 relative" style="background: #F7FAFC">
      <container>        <!-- Search tabs -->
        <div class="my-10 search-tabs mx-auto">
          <div class="tabs flex lg:mx-3">
            <button class="bg-gray-300 hover:bg-gray-400 text-gray-800  py-2 px-2 md:px-4 focus:shadow-none hover:border-gray-600 border-b-2 border-transparent transition-colors duration-200 ease-in"
            @click="activeTab('doctor-search')" :class="[{'bg-gray-400 border-gray-600' : currentTabComponent == 'doctor-search'}, {'rounded-tl': !isRtl}, {'rounded-tr': isRtl}]">
              {{ $t('general.doctors') }}
            </button>
            <button @click="activeTab('dentist-search')"
             :class="[{'bg-gray-400 border-gray-600' : currentTabComponent == 'dentist-search'}]"
             class="bg-gray-300 hover:bg-gray-400 text-gray-800  py-2 px-2 md:px-4 focus:shadow-none  hover:border-gray-600 border-b-2 border-transparent transition-colors duration-200 ease-in">
               {{ $t('general.dentists') }}
            </button>
            <button class="bg-gray-200  text-gray-400  py-2 px-2 md:px-4 focus:outline-none"
            :content="$t('pages.home.tabs.disabled')" 
            v-tippy="{trigger : 'click'}"
            >
                {{ $t('general.beautyCenters') }}
            </button>

            <button 
            class="bg-gray-200  text-gray-400  py-2 px-2 md:px-4 focus:outline-none focus:shadow-none"
            :content="$t('pages.home.tabs.disabled')" 
            v-tippy="{trigger : 'click'}"
            :class="[{'bg-gray-400' : currentTabComponent == 'pharmacy-search'}, {'rounded-tr': !isRtl}, {'rounded-tl': isRtl}]"
            >
              {{ $t('general.pharmacies') }}
            </button>
          </div>

          <div class="tab-content flex items-center rounded-md bg-white shadow p-6 md:p-8 relative" style="min-height: 203px">
            <keep-alive>
              <transition name="fade-bottom" mode="out-in">
                <component v-bind:is="currentTabComponent"></component>
              </transition>
            </keep-alive>
          </div>
        </div>
        <!-- End of Search tabs -->
      </container>
    </header>

    <container>
      <header-image></header-image>
      <p class="text-center uppercase tracking-wider text-awro-600">{{ $t('slugan') }}</p>
      
      <vertical-padding>
       <consulting-hero></consulting-hero>
      </vertical-padding>

      <vertical-padding>
        <article-carousel :headline="$t('pages.home.article.headline')"></article-carousel>
      </vertical-padding>

      <vertical-padding>
        <doctor-hero></doctor-hero>
      </vertical-padding>
    </container>

    <mobile-app-hero></mobile-app-hero>
  </div>
</template>

<script>
/*eslint-disable */

import Alert from '@/components/Alert';
import Container from '@/components/Container';
import HeadLine from '@/components/theme/HeadLine';
import DoctorSearch from '@/components/search/DoctorSearchPanel'
import DentistSearch from '@/components/search/DentistSearchPanel'
// import PharmacySearch from '@/components/search/PharmacySearchPanel'
// import BeautySearch from '@/components/search/BeautySearchPanel'
import HeaderImage from '@/components/theme/HeaderImage';
import {mapGetters} from 'vuex';
import ArticleCarousel from '@/components/layout/home/ArticleCarousel'
import Api from '@/api'
import ArticlePlaceholder from '@/components/layout/home/ArticlePlaceholder';
import DoctorHero from '@/components/layout/home/DoctorHero'
import VerticalPadding from '@/components/layout/VerticalPadding'
import MobileAppHero from '@/components/layout/home/MobileAppHero';
import ConsultingHero from '@/components/layout/home/ConsultingHero'
/*eslint-enable */

export default {
  name: 'Home',
  components: {
    Alert,
    Container,
    HeadLine,
    DoctorSearch,
    DentistSearch,
    // PharmacySearch,
    // BeautySearch,
    HeaderImage,
    ArticleCarousel,
    DoctorHero,
    VerticalPadding,
    MobileAppHero,
    ConsultingHero
    },
  data() {
    return {
      currentTabComponent: 'doctor-search'
    }
  },
  methods: {
    activeTab(tab) {
      this.currentTabComponent = tab;
    }
  },
  computed: {
    ...mapGetters({
      isRtl: ['locale/IS_RTL'],
    })
  },
   metaInfo() {
    return {
      title: this.$i18n.t('awronore') + ' | ' + this.$i18n.t('pages.home.title'),
      meta: [
        {name: 'description', content: this.$i18n.t('awro-desc')},
      ],
      htmlAttrs: {
        amp: true,
        lang: this.$i18n.locale
      } 
    } 
  }
}
</script>
